import { getMsanPreviewStyles } from '@bingads-webui-campaign-react/shared-image-preview-styles';

export const editImageCommonStyle = () => ({
  ...getMsanPreviewStyles(),
});
